export default __webpack_public_path__ + "static/media/get_string.d2cd1a4b.png";